/* eslint-disable angular/window-service */
export const technology = {
  isAngular: window.technology === 'angular',
  isReact: window.technology === 'react',
};

export default ['TECHNOLOGY', technology];
